import { DT_SCREEN } from '@/core/constants/dynatraceScreens';
import { useCatalogDynatraceView } from '@/core/hooks/useCatalogDynatraceView';
import { logger } from '@/core/logger';
import { navigateToWelcomeAfterLogout } from '@/core/navigation/logoutNavigation';
import { LogoutSuccessScreen } from '@/modules/profile/components/LogoutSuccessScreen';
import React from 'react';

export default function LogoutSuccessRoute() {
    useCatalogDynatraceView(DT_SCREEN.LOGOUT_SUCCESS, 'logout_success_viewed', true);
    const handleGoToLogin = () => {
        // Navigate to welcome/login entry screen and clear stack
        navigateToWelcomeAfterLogout().catch((error) => {
            logger.error('LogoutSuccessRoute', 'Failed to navigate after logout', error);
        });
    };

    return <LogoutSuccessScreen onGoToLogin={handleGoToLogin} />;
}
